import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCloseXs = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M13.2014 12.4932L17.8474 7.84723C18.0368 7.65104 18.0341 7.33919 17.8413 7.14632C17.6484 6.95346 17.3365 6.95075 17.1404 7.14023L12.4944 11.7862L7.84836 7.14023C7.65217 6.95075 7.34031 6.95346 7.14745 7.14632C6.95458 7.33919 6.95187 7.65104 7.14136 7.84723L11.7864 12.4932L7.14036 17.1392C6.95087 17.3354 6.95358 17.6473 7.14645 17.8401C7.33931 18.033 7.65117 18.0357 7.84736 17.8462L12.4944 13.2012L17.1404 17.8472C17.3365 18.0367 17.6484 18.034 17.8413 17.8411C18.0341 17.6483 18.0368 17.3364 17.8474 17.1402L13.2014 12.4932Z' />
  </svg>
);
export default SvgCloseXs;
